import React from 'react';
import { Box } from "@chakra-ui/react";
import Head from 'next/head';
export const Layout: React.FunctionComponent = (props) => {
  return (
    <>
      <Head>
        <link rel="icon" type="image/png" href="/favicon.png" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
      </Head>
      <Box
        sx={{
          // fontFamily: "default",
          img: {
            maxWidth: "100%",
          },
        }}
      >
        {props.children}
      </Box>
    </>

  );
};
